import { Suspense, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import routes from './routes.json';
import SessionRoute from './SessionRoute';
import { useEffect, useState} from 'react';
import {isSessionExpired,getSessionStatus} from '../session/auth.js';

const Login = lazy(() => import('../session/Login'));
const Signup = lazy(() => import('../session/Signup'));
const Migration = lazy(() => import('../session/Migration'));
const InvitedUser = lazy(() => import('../content/InvitedUser'));
const ForgotPassword = lazy(() => import('../content/ForgotPassword'));
const ResetPassword = lazy(() => import('../content/ResetPassword'));
const AuthorisePayment = lazy(() => import('../content/AuthorisePayment'));
const Enterprise = lazy(() => import('../content/Enterprise'));

const route = routes.contentroutes;

function ContentRoutes() {

  const [sessStatusFlag, setSessStatusFlag] = useState(false)

  useEffect(() => {
    setSessStatusFlag(false)
    // checking only sessStatus is not enough because in some case we are not removing session when it is expired 
    if(getSessionStatus()) {
      isSessionExpired().then(() => {
        setSessStatusFlag(true)
      })
    }
    else {
      setSessStatusFlag(true)
    }
  },[])

  return (
    <div className='page_container content'>
      <header className='content_header'>
        <a href='/' className='company_logo' target='_top' />
      </header>
      {
        sessStatusFlag && 
        <div className='main_wrapper'>
          <div className='main_container'>
            <Switch>
              <Suspense fallback={<div>Loading...</div>}>
                <SessionRoute exact path={route.login} component={Login} />
                <SessionRoute exact path={route.signup} component={Signup} />
                <SessionRoute exact path={route.migration} component={Migration} />
                <SessionRoute exact path={route.inviteduser} component={InvitedUser} />
                <SessionRoute exact path={route.forgotpassword} component={ForgotPassword} />
                <SessionRoute exact path={route.resetpassword} component={ResetPassword} />
                <SessionRoute exact path={route.authorisepayment} component={AuthorisePayment} />
                <SessionRoute exact path={route.enterprise} component={Enterprise} />
              </Suspense>
            </Switch>
          </div>
        </div>
      }
    </div>
  )
}

export default ContentRoutes;
